export default "__VITE_ASSET__DQtYIJjw__"